<template>
        <h2 class="d-inline">{{ $trans.get('__JSON__.Expired qualifications') }}
            <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ getCountExpiredQualifications() }} </div> </h2>
    <table class="table table-striped hover-zoom">
        <thead>
            <tr>
            <th role="button" @click.prevent="sortColumn = 'employee'">
                {{ $trans.get('__JSON__.Employee') }}
                <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'team'">
                {{ $trans.get('__JSON__.Team') }}
                <i v-if="sortColumn == 'team'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Qualification') }}
            </th>
            <th role="button" @click.prevent="sortColumn = 'expired'">
                {{ $trans.get('__JSON__.Expires at') }}
                <i v-if="sortColumn == 'expired'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Actions') }}
            </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="expiredQualification in sortedExpiredQualifications" :key="'eq-' + expiredQualification.id">
                <td>
                    {{ makeFullname(expiredQualification.employee.lastname, expiredQualification.employee.forename) }}
                </td>
                <td>
                    {{ expiredQualification.employee.team?.name }}
                </td>
                <td>
                    {{ expiredQualification.qualification.qualificationgroup.name }}
                    {{ expiredQualification.qualification.name }}
                </td>
                <td>
                    <i v-if="isYesterdayOrBefore(expiredQualification.refresh_at)" class="fa fa-warning text-danger"
                        v-tooltip title="Warnung älter als ein Tag!"></i>&nbsp;
                    {{ toYMDFormat(expiredQualification.refresh_at) }}
                </td>
                <td>
                    <div class="input-group">
                        <select v-model="expiredQualification.training_id" class="form-control form-control-xs" id="training_id" name="training_id">
                            <option value="0" selected="selected">{{ $trans.get('__JSON__.Choose training') }}</option>
                            <template v-for="training of trainings">
                                <option v-if="training.qualification_id == expiredQualification.qualification_id"
                                    :value="training.id" :key="training.id"> {{ buildTrainingName(training) }}</option>
                            </template>
                        </select>
                        <button class="btn btn-primary"
                            @click="setTraining(expiredQualification)">{{
            $trans.get('__JSON__.Assign')
        }}</button>
                        <button class="endqualification btn btn-danger"
                            @click="oldingQualification(expiredQualification)"
                            :title="'' + $trans.get('__JSON__.End qualification')" data-toggle="tooltip"><i
                                class="fa fa-circle-xmark"></i></button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <Teleport to="body">
        <div class=" modal modal-fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="mediumModalLabel"
            aria-hidden="false">
            <div class="modal-dialog modal-sm ">
                <div class="modal-content">
                    <div class=" modal-header ">
                        <div class="row">
                            <div class="col-12">
                                <h2>{{ $trans.get('__JSON__.Error on save') }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="text-center modal-body" id="mediumBody">
                        <span class="text-center material-symbols-outlined material-symbols-error">
                            error
                        </span>
                        <div class="text-center alert alert-block alert-danger">
                            <h4 class="text-center">{{ expiredQualification_error }} {{ trainingResponse?.status }}</h4>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans.get('__JSON__.Confirm')
                            }}</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<script>
import getExpiredQualifications from "../composables/expiredQualifications";
import getTrainings from "../composables/getTrainings";

export default {

    name: "ExpiredQualifications",

    props: {
        monitor_others: Boolean,
        view_locations: Object
    },
    setup(props) {
        const { expiredQualifications, expiredQualification_error, loadExpiredQualifications, assignTraining, endQualification, trainingResponse} = getExpiredQualifications();
        loadExpiredQualifications(props.monitor_others, props.view_locations, props.year);
        const { trainings, trainings_error, loadTrainings } = getTrainings();
        loadTrainings();

        return {
            expiredQualifications, expiredQualification_error, loadExpiredQualifications, assignTraining, endQualification,
            trainings, trainings_error, loadTrainings, trainingResponse
        };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
        };
    }, 
    created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
    },
    computed: {
        sortedExpiredQualifications() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.expiredQualifications) {
                $('#expiredQualificationsContainer').css('display', 'none');
                return null;
            }
            if (this.expiredQualifications.length == 0) {
                $('#expiredQualificationsContainer').css('display', 'none');
                return null;
            }
            $('#expiredQualificationsContainer').css('display', 'block');
            return this.expiredQualifications.sort(this.compareExpiredQualifications).filter(expiredQualification => expiredQualification.paused == 0);
        }
    },
    methods: {
        buildTrainingName(training) {
            var trainingName = training.title + ' ' + training.start_at;
            if (training.max_participants > 0) {
                trainingName += ' (' + training.employee_count + ' / '+ training.max_participants + ')';
            }
            return  trainingName;
        },
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd;

            return formattedDate;

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi;

            return formattedDate;

        },
        compareExpiredQualifications(a, b) {
            if (this.sortColumn == 'expires_at') {
                if (a.expires_at == b.expires_at) {
                    return 0;
                }
                if (a.expires_at < b.expires_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'team') {
                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }
                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
            }

            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }
                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }
                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }
                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }
                if (a.expires_at > b.expires_at) {
                    return 1;
                }
                if (a.expires_at < b.expires_at) {
                    return -1;
                }
                return 0;
            }
            return 0;
        },
        getCountExpiredQualifications() {
            if (!this.sortedExpiredQualifications) {
                return counted = 0;
            }
            let counted = this.sortedExpiredQualifications.length;
            return counted;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        },
        makeFullname(lastname, forename) {
            const fullname = lastname + ', ' + forename;
            return fullname;
        },
        async setTraining(expiringQualification) {
            this.expiredQualification_error = null;
                await (this.assignTraining(expiringQualification));
                console.log("trainingresponse: ", this.trainingResponse);

                if (this.expiredQualification_error || this.trainingResponse?.ok == 0) {
                    console.log("error: ", this.expiredQualification_error);
                    console.log("error: ", this.trainingResponse.status);
                    $("#errorModal").modal("show");
                }
                else {
                    this.expiredQualifications = this.expiredQualifications.filter(function (value, index, arr) {
                        return value.id != expiringQualification.id;
                    });
                    this.loadTrainings();
                }
        },
        async oldingQualification(expiringQualification) {
            console.log('test olding: ', expiringQualification)
            this.expiredQualification_error = null;
            expiringQualification.old = 1;
                await (this.endQualification(expiringQualification));
                if (this.expiredQualification_error) {
                    console.log("error: ", this.expiredQualification_error);
                    $("#errorModal").modal("show");
                }
                else {
                    this.expiredQualifications = this.expiredQualifications.filter(function (value, index, arr) {
                        return value.id != expiringQualification.id;
                    });
                }
        },
        refreshData() {
            this.loadExpiredQualifications(this.monitor_others, this.view_locations);
        },
    }
}

</script>